import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import createPersistedState from "vuex-persistedstate"  
Vue.use(Vuex);

const state = {
  zh: {
    news: [],
    recruitment: {}
  },
  en: {
    news: [],
    recruitment: {}
  }
};

const mutations = {
  getZh(state, data) {
    state.zh = data;
  },
  getEn(state, data) {
    state.en = data;
  }
};

const actions = {
  getZh(context) {
    axios
      .get("/static/zh.json")
      .then(data => {
        context.commit("getZh", data.data);
      })
      .catch(err => {
        console.error(err);
      });
  },
  getEn(context) {
    axios
      .get("/static/en.json")
      .then(data => {
        context.commit("getEn", data.data);
      })
      .catch(err => {
        console.error(err);
      });
  }
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  plugins: [createPersistedState({
    reducer(val)  {
      return {
        zh: val.zh,
        en: val.en
      }
    }
  })]
});



// WEBPACK FOOTER //
// ./src/store/index.js